var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-alerts_svg__cls-2,.kpmg-alerts_svg__cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.6px}.kpmg-alerts_svg__cls-2{stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-alerts_svg__ICN_FAlerte_termene_Enabled",
    "data-name": "ICN_FAlerte termene_Enabled",
    transform: "translate(-133 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Polygon_10",
    "data-name": "Polygon 10",
    d: "M21.679 0a4 4 0 013.473 2.015l5.714 10a4 4 0 010 3.969l-5.714 10A4 4 0 0121.679 28H10.321a4 4 0 01-3.473-2.015l-5.714-10a4 4 0 010-3.969l5.714-10A4 4 0 0110.321 0z",
    transform: "translate(133 232)",
    fill: "#004a9b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-alerts_svg__Group_1492",
    "data-name": "Group 1492",
    transform: "translate(22.5 83.088)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-alerts_svg__Rectangle_320",
    "data-name": "Rectangle 320",
    className: "kpmg-alerts_svg__cls-2",
    width: 11.469,
    height: 2.72,
    rx: 1.36,
    transform: "translate(120.661 166.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Rectangle_321",
    "data-name": "Rectangle 321",
    className: "kpmg-alerts_svg__cls-2",
    d: "M3.441 0a3.441 3.441 0 013.44 3.441V7.6H0V3.441A3.441 3.441 0 013.441 0z",
    transform: "translate(122.955 158.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Line_156",
    "data-name": "Line 156",
    className: "kpmg-alerts_svg__cls-3",
    transform: "translate(120.5 159.197)",
    d: "M0 0h1.308"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Line_157",
    "data-name": "Line 157",
    className: "kpmg-alerts_svg__cls-3",
    transform: "translate(130.983 159.197)",
    d: "M0 0h1.055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Line_158",
    "data-name": "Line 158",
    className: "kpmg-alerts_svg__cls-3",
    transform: "rotate(90 -13.946 140.055)",
    d: "M0 0h1.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Line_159",
    "data-name": "Line 159",
    className: "kpmg-alerts_svg__cls-3",
    transform: "rotate(45 -127.12 225.628)",
    d: "M0 0h1.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-alerts_svg__Line_160",
    "data-name": "Line 160",
    className: "kpmg-alerts_svg__cls-3",
    transform: "rotate(135 32.938 105.01)",
    d: "M0 0h1.72"
  })))));
}

export default SvgKpmgAlerts;